<mat-label>Product Type</mat-label>
<app-search-dropdown
    [dataSource]="productTypes"
    [control]="productTypeControl"
></app-search-dropdown>